export default __webpack_public_path__ + "static/media/Beetlejuice.ced3a242.mp3";